export default {"src":"/_next/static/media/03_Gift_EN.ada74f37.gif","height":175,"width":439};